import { useErrorBoundary } from '../../../hooks/useErrorBoundary';
import { ErrorFallback } from '../../atoms';
import { ErrorBoundaryProps } from '../../../types';

export const ErrorBoundary: React.FC<ErrorBoundaryProps> = ({
  children,
  fallback: Fallback = ErrorFallback,
}) => {
  const { hasError, error, resetError } = useErrorBoundary();

  if (hasError && error) {
    return <Fallback error={error} resetError={resetError} />;
  }

  return <>{children}</>;
};
